import React from "react";
import "./Card.css";

const Card = ({emoji, icon, heading, detail, color}) => {
  return (
    <div className="card" style={{borderColor: {color}}}> 
      {icon ? (
        <div className="c-icon">{icon}</div>
      ) : (
        <img src={emoji} alt="" />
      )}
      <span>{heading}</span>
      <span>{detail}</span>
      <button className="c-button">LEARN MORE</button>
    </div>
  );
};

export default Card;
